import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

import { RADIUS_1 } from '@Styles/constants/radius'
import { getFocusVisibleStyle } from '@Styles/focus'
import { type Surface } from '@Types/surface'

export const link = (theme: Theme, surface: Surface): SerializedStyles =>
  css({
    '&:focus-visible::before': getFocusVisibleStyle(
      surface === 'onPrimary' ? theme.palette.primary.contrastText : theme.palette.primary.main,
      RADIUS_1,
      `0`,
    ),
    alignItems: 'center',
    justifyContent: 'center',
  })
